/** User-facing message strings — centralised for consistency and i18n readiness. */
export const MESSAGES = {
  AUTH: {
    LOGIN_SUCCESS: 'Signed in successfully.',
    LOGIN_FAILED: 'Invalid email or password.',
    LOGOUT_SUCCESS: 'You have been signed out.',
    SESSION_EXPIRED: 'Your session has expired. Please sign in again.',
  },
  ERRORS: {
    NETWORK: 'Network error. Please check your connection and try again.',
    UNAUTHORIZED: 'You are not authorised to perform this action.',
    FORBIDDEN: 'You do not have permission to access this resource.',
    NOT_FOUND: 'The requested resource was not found.',
    SERVER: 'Something went wrong on our end. Please try again later.',
    GENERIC: 'Something went wrong. Please try again.',
  },
};

export default MESSAGES;
